import { render, staticRenderFns } from "./QnaView.vue?vue&type=template&id=5af2a695&scoped=true&"
import script from "./QnaView.vue?vue&type=script&lang=js&"
export * from "./QnaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2a695",
  null
  
)

export default component.exports